/**
 * <s-share> — share a product from its page.
 *
 * [data-share-native] reveals only where the device share sheet exists (most phones),
 * which reaches Instagram, WhatsApp and every other installed app.
 * [data-share-copy] copies the link and briefly confirms in [data-share-status].
 * The WhatsApp link is a plain anchor and works without JavaScript.
 */
class SShare extends HTMLElement {
  #ac;
  #timer = 0;

  connectedCallback() {
    this.url = this.dataset.url || window.location.href;
    this.shareTitle = this.dataset.title || document.title;
    this.status = this.querySelector('[data-share-status]');
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };

    const native = this.querySelector('[data-share-native]');
    if (native && typeof navigator.share === 'function') {
      native.hidden = false;
      native.addEventListener('click', () => {
        navigator.share({ title: this.shareTitle, url: this.url }).catch(() => {});
      }, opts);
    }

    this.querySelector('[data-share-copy]')?.addEventListener('click', () => this.#copy(), opts);
  }

  disconnectedCallback() {
    this.#ac?.abort();
    clearTimeout(this.#timer);
  }

  async #copy() {
    try {
      await navigator.clipboard.writeText(this.url);
    } catch {
      return;
    }
    if (!this.status) return;
    this.status.textContent = this.dataset.copied || '';
    this.status.dataset.visible = '';
    clearTimeout(this.#timer);
    this.#timer = setTimeout(() => {
      delete this.status.dataset.visible;
      this.status.textContent = '';
    }, 2200);
  }
}

if (!customElements.get('s-share')) {
  customElements.define('s-share', SShare);
}
